<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="space-1">
  <a [routerLink]="['../']">< Teaching CEUs</a>

  <h4>{{ courseEvent.title }} - Teaching Certificate</h4>

  <div class="form-row">
    <div class="col-md-6">
      <label>What Kind of Certificate Would You Like to View?</label>
      <select class="form-control" [(ngModel)]="selectedBody" (change)="selectionChanged($event)">
        <option value="">Please choose...</option>
        <option *ngFor="let cert of certifications" [ngValue]="cert">{{ cert.certificationBody.name }}</option>
      </select>
    </div>
    <div class="col-md-6">
      <button type="button" *ngIf="selectedBody?.userHasGenerated == false" [disabled]="!selectedBody"
              (click)="generateCertificate(false)" class="btn btn-admin-primary mt-5 mr-2">Generate
      </button>
    </div>
  </div>
</div>

<div *ngIf="currentCertificate && !currentCertificate.userCertification" class="row no-gutters no-candidates"
     style="min-height: 200px">
  <div class="col-sm-12 my-auto">
    <h1><i class="fas fa-empty-set"></i></h1>
    <h4>No Credentials</h4>
    <p>You have not added a your credentials for {{ currentCertificate.certification.certificationBody.shortName }} CEUs
      yet. You will need to add certifications to
      claim {{ currentCertificate.certification.certificationBody.shortName }} CEUs.</p>
    <button class="btn btn-sm btn-admin-primary" (click)="addCertification()" type="button">Add Certification</button>
  </div>
</div>

<div *ngIf="currentCertificate && !currentCertificate.paidForCEUs" class="row no-gutters no-candidates"
     style="min-height: 200px">
  <div class="col-sm-12 my-auto">
    <h1><i class="fas fa-sack-dollar"></i></h1>
    <h4>Not Paid</h4>
    <p>This Organization charges extra for CEUs and you haven't paid yet. Click below to purchase the CEU package.</p>
    <button class="btn btn-sm btn-admin-primary" type="button">Purchase CEUs</button>
  </div>
</div>

<div *ngIf="currentCertificate && currentCertificate.events.length == 0" class="row no-gutters no-candidates"
     style="min-height: 200px">
  <div class="col-sm-12 my-auto">
    <h1><i class="fas fa-file-certificate"></i></h1>
    <h4>No CEUs</h4>
    <p>You didn't earn any {{ currentCertificate.certification.certificationBody.shortName }} CEUs for this event.
      Please review the event and resolve if possible.</p>
    <a class="btn btn-sm btn-admin-primary" [routerLink]="['../']" role="button">Review & Fix CEUs</a>
  </div>
</div>

<div *ngIf="currentCertificate && !currentCertificate.certificatesReleased" class="row no-gutters no-candidates"
     style="min-height: 200px">
  <div class="col-sm-12 my-auto">
    <h1><i class="fas fa-file-certificate"></i></h1>
    <h4>Still Processing...</h4>
    <p>This certificate has not been released by the conference organization. Please check back soon!</p>
  </div>
</div>

<!-- <div class="row no-gutters no-candidates" style="min-height: 200px">
  <div class="col-sm-12 my-auto">
    <h1><i class="fas fa-download"></i></h1>
    <h4>Request?</h4>
    <p>This conference requires final approval for certificates of this type. <br>Once ALL assessments are complete,
      you can request this certificate be released.</p>
    <button class="btn btn-sm btn-admin-primary" type="button">Request CEUs</button>
  </div>
</div> -->
<page-load-header *ngIf="loading"></page-load-header>
<div *ngIf="currentCertificate && currentCertificate.isValid" class="row">
  <div class="col-md-12 text-right mb-1">
    <button type="button" (click)="pdf.saveAs(courseEvent.title + ' Certificate.pdf')" [promiseBtn]="submitComplete"
            class="btn btn-sm btn-admin-primary mt-5">Download PDF
    </button>
  </div>
  <kendo-pdf-export #pdf paperSize="A4" margin="1cm" [scale]=".7">
    <div id="printDiv" class="col-md-12 card p-3">
      <div *ngIf="currentCertificate.certification.headerImageAssetPath" style="text-align: center; width: 100%"
           class="">
        <img class="img-fluid" style="max-height: 200px; max-width: 500px;"
             src="https://bxlimages.blob.core.windows.net/images/{{ currentCertificate.certification.headerImageAssetPath }}"/>
      </div>
      <div class="text-center">
        <h5 class="">
          {{ currentCertificate.certification.certificationBody.name }}
        </h5>
        <h5>CERTIFICATE OF TEACHING – CONTINUING EDUCATION</h5>
        <h5>
          <p>
            <small>{{ currentCertificate.certification.notes }}</small>
          </p>
        </h5>
        <h2 class="conference-title">{{ currentCertificate.events[0].title }}</h2>
        <h5>{{ currentCertificate.events[0].instructor.fullNameWithCredentials }}</h5>
        <h6>{{ currentCertificate.events[0].ceuParticipationDate | date: 'short' }}</h6>
        <p>presented by</p>
        <h3 class="organization-name">
          {{ currentCertificate.certification.ceuProviderName }}
          <small> [{{ currentCertificate.certification.ceuProviderCode }}]</small>
        </h3>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h6 class="">
            <strong>Instructor
              Name: </strong>{{ currentCertificate.user.firstName + ' ' + currentCertificate.user.lastName }}
          </h6>
          <h6 class="">
            <strong> {{ currentCertificate.userCertification.certificationBody.name }} </strong><span
            class="">#: {{ currentCertificate.userCertification.certificationNumber }}</span>
          </h6>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="panel panel-success">
            <div class="panel-heading">
              <h5 class="ceu-title">Total {{ currentCertificate.certification.certificationBody.unitName }}</h5>
            </div>
            <div class="panel-body ceu-info-number">{{ totalCEs }}</div>
          </div>
        </div>

        <div *ngIf="currentCertificate.certification.certificationBody.subType1Name" class="col-md-4">
          <div class="panel panel-info">
            <div class="panel-heading">
              <h5
                class="ceu-title">{{ currentCertificate.certification.certificationBody.subType1Name }} {{ currentCertificate.certification.certificationBody.unitName }}</h5>
            </div>
            <div class="panel-body ceu-info-number">{{ totalCEsSubType1 }}</div>
          </div>
        </div>
        <div *ngIf="currentCertificate.certification.certificationBody.subType2Name" class="col-md-4">
          <div class="panel panel-info">
            <div class="panel-heading">
              <h5
                class="ceu-title">{{ currentCertificate.certification.certificationBody.subType2Name }} {{ currentCertificate.certification.certificationBody.unitName }}</h5>
            </div>
            <div class="panel-body ceu-info-number">{{ totalCEsSubType2 }}</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="text-right">
            <p class="">{{ currentCertificate.certification.certificationBody.unitName }} collected and verified
              using</p>
            <h4 class="brand-name">{{ settings.brand.brandName }}</h4>
            {{ settings.brand.url }}
          </div>
        </div>
      </div>

      <div *ngIf="currentCertificate.certification.footerImageAssetPath" style="text-align: left; width: 100%" class="">
        <img class="img-fluid" style="max-height: 100px"
             src="https://bxlimages.blob.core.windows.net/images/{{ currentCertificate.certification.footerImageAssetPath }}"/>
      </div>
    </div>
  </kendo-pdf-export>
</div>
